import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useGet } from '../hooks/useGet'
import { useDelete } from '../hooks/useDelete'
import { useConfirm } from '../hooks/useConfirm'
import { RadAppLayout } from '../common/RadAppLayout'
import { RadBreadcrumbGroup } from '../common/RadBreadcrumbGroup'
import { RadButton } from '../common/RadButton'
import { RadHeader } from '../common/RadHeader'
import { RadSpaceBetween } from '../common/RadSpaceBetween'
import { CollaborativeDetailContent } from './CollaborativeDetailContent'

export function CollaborativeDetail () {
  const navigate = useNavigate()
  const { collaborativeId } = useParams()
  const { data: collaborative } = useGet(`/api/collaborative/${collaborativeId}`, true)
  const { data: currentUser } = useGet('/api/user/current')
  const confirmDelete = useConfirm('Delete collaborative?', 'Delete collaborative permanently? This action cannot be undone.', 'Delete', () => { remove() })
  const remove = useDelete(`/api/collaborative/${collaborativeId}`, () => { navigate('/collaborative') })

  function edit (evt) {
    evt.preventDefault()
    navigate('edit')
  }

  if (collaborative != null && currentUser != null) {
    return (
      <RadAppLayout
        breadcrumbs={
          <RadBreadcrumbGroup
            items={[
              { text: 'Home', href: '/' },
              { text: 'Organizations & Collaboratives', href: '/organization-collaborative' },
              { text: collaborative.name }
            ]}
            ariaLabel='Breadcrumbs'
          />
        }
        contentHeader={
          <RadHeader
            variant='h1'
            actions={
              <RadSpaceBetween direction='horizontal' size='xs'>
                {collaborative.canEdit && <RadButton onClick={edit}>Edit</RadButton>}
                {collaborative.canDelete && <RadButton onClick={confirmDelete} disabled={collaborative.isProtected}>Delete</RadButton>}
              </RadSpaceBetween>
            }
          >
            {collaborative.name}
          </RadHeader>
        }
        content={
          <CollaborativeDetailContent collaborative={collaborative} />
        }
      />
    )
  }
}
